import { render } from "./AddressNotFoundErrorModal.vue?vue&type=template&id=ba173e50"
const script = {}

import "./AddressNotFoundErrorModal.vue?vue&type=style&index=0&id=ba173e50&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__